
export default {
  data() {
    return {
			dadosCardRendaPassiva: null
    }
  },

  mounted() {

		this.getDadosTabela()
  },



  methods: {

    formatReal(param) {
      return GLOBAL.FormatREALVirgula(param)
    },

		async getDadosTabela(numPagina = 1, numLinhas = 999 ) {
			try{
				const base = window.location.origin
				const url = `${base}/api/eventos_provisionados/dividendos/?resumo=True`
				const {data} = await axios.get(url)
				this.dadosCardRendaPassiva = await data

			}
			catch(err){
				console.log(err)
			}

		}

  },

  delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django
}